module.exports = __webpack_public_path__ + "static/media/aws-certified-sysops-administrator-associate.ed730a7d.png";